const ICU = require('i18next-icu').default || require('i18next-icu')

/**
 * @type {import('next-i18next').UserConfig}
 */
module.exports = {
    serializeConfig: false,
    use: [ICU],
    localePath: 'public/locales',
    reloadOnPrerender: process.env.NODE_ENV === 'development',
    saveMissing: process.env.NODE_ENV === 'development',
    i18n: {
        defaultLocale: 'en',
        locales: [
            'en',
            'ru',
            'fr',
            'nl',
            'pt-BR',
            'zh-CN',
            'ko',
            'nb',
            'de',
            'sv',
            'tr',
            'it',
            'da',
            'pl',
            'fi',
            'zh-TW',
            'ja',
            'es',
            'cs',
        ],
        localeDetection: false,
    },
}
